import { computed } from 'vue';
import { useMediaQuery } from '@vueuse/core';

const MOBILE_USER_AGENT_PATTERN =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const isMobileUserAgent = () => {
  if (typeof navigator === 'undefined') return false;

  if (typeof navigator.userAgentData?.mobile === 'boolean') {
    return navigator.userAgentData.mobile;
  }

  const isIPadOS =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return isIPadOS || MOBILE_USER_AGENT_PATTERN.test(navigator.userAgent);
};

export const useMobileDevice = () => {
  const isNarrowViewport = useMediaQuery('(max-width: 767px)');
  const isMobile = isMobileUserAgent();

  return computed(() => isNarrowViewport.value && isMobile);
};
